
 export const environment = {
  production: true,
   leaflefApiKey: 'wly6pnqvmbuioatp8an1zigi6n3h6mntxr5c4mxw',
   defaultCountryCode:'+91',
   API_VERSION: 1,
   MSALTenantId: '11cfefb8-7514-417b-83d2-9c8aa33447ea',
   redirectUrl: 'https://zan-preprod-crm-web.azurewebsites.net/common-dashboard',
   MSALClientId: 'd8d45041-75a5-4200-980f-74e5e10907d1',
   postLogoutRedirectUri: 'https://zan-preprod-crm-web.azurewebsites.net/login?isLoggedOut=true',
   setRoutingApi:'http://102.133.231.187:7710/api/',
   ITManagementApi: 'https://zan-preprod-itmgmt.azurewebsites.net/api/',
   customerManagementApi: 'https://zan-preprod-customer.azurewebsites.net/api/',
   SALES_API: 'https://zan-preprod-sales.azurewebsites.net/api/',
   inventoryApi: 'https://zan-preprod-inventory.azurewebsites.net/api/',
   authenticationApi: 'https://zan-preprod-authentication.azurewebsites.net/api/',
   callCenterApi: 'https://fidelity-callcenter-dev.azurewebsites.net/',
   telephonyApi: 'https://zan-preprod-telephony.azurewebsites.net/api/',
   billingApi: 'https://zan-preprod-billing.azurewebsites.net/api/',
   TRANSLATOR_CONFIG_API: 'https://zan-preprod-translator-tcm.azurewebsites.net/api/',
   EVENT_MANAGEMENT_API: 'https://zan-preprod-eventmgmt.azurewebsites.net/api/',
   COMMON_API: 'https://zan-preprod-shared.azurewebsites.net/api/',
   technicianAPI: 'https://zan-preprod-technician.azurewebsites.net/api/',
   sharedApi: 'https://zan-preprod-shared.azurewebsites.net/api/',
   FILE_PROCESS_API: 'https://zan-preprod-fileprocessing.azurewebsites.net/api/',
   DEALER_API: 'https://zan-preprod-dealer.azurewebsites.net/api/',
   COLLECTIONS_API: 'https://zan-preprod-collection.azurewebsites.net/api/',
   OPEN_SCAP_EMAIL_API: 'http://102.133.231.187/api/',
   PANIC_APP_API: 'https://zan-preprod-personal-panic.azurewebsites.net/api/',
   PTT_UI: 'https://zan-preprod-italk.azurewebsites.net/',
   pdfUrl: 'https://zan-preprod-pdf.azurewebsites.net/api/',
 };
